// extracted by mini-css-extract-plugin
export default {"learnCardsPage":"LearnCardsPage_learnCardsPage__Y-KeC","contentContainer":"LearnCardsPage_contentContainer__1ZlpV"};